
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function TTFCommitmentFiscalYearHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '150px',
				minWidth: '150px',
				maxWidth: '150px'
			}}>
			TTF commitment fiscal year
		</StickyHeader>
	)
}

export function TTFCommitmentFiscalYearFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.TTFCommitmentFiscalYearValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							TTFCommitmentFiscalYearValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.TTFCommitmentFiscalYear ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							TTFCommitmentFiscalYear: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function TTFCommitmentFiscalYearContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.TTFCommitmentFiscalYearValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.TTFCommitmentFiscalYear}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}